import { Star } from "lucide-react";

const reviews = [
  {
    name: "Julie",
    text: "A couple of months ago I had a ducted air con system installed and a split-system relocated to another room by ACG. I cannot recommend ACG highly enough. The ladies I spoke to in the office were all very helpful. Likewise the guys who came out to do the installation were wonderful.",
  },
  {
    name: "Laudi Rizk",
    text: "We have been using ACG for our monthly servicing in our office for over a year now and they do an amazing job. Since using ACG, we have not had any issues compared to our previous contractors. Thank you Andrew and the Team for being so accommodating and helpful.",
  },
  {
    name: "Ginette Moffett",
    text: "Brothers Chris and Andrew are very professional, efficient, and hard working young men. Their leadership shows across the board as the young men in the repair teams are hard working and efficient. I have used this company on the commercial side and would highly recommend.",
  },
  {
    name: "Rebecca Gee",
    text: "The whole process from getting a recommendation about a unit, to the booking in and then the installation was so easy. Elias and his colleague were so friendly and really knowledgeable during the installation. We will definitely use them again!",
  },
];

const Testimonials = () => {
  return (
    <section className="py-16 px-4">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl font-bold text-foreground mb-2">What Our Clients Say</h2>
        <p className="text-muted-foreground mb-6">
          For Over 15 Years, ACG has been Built on Pride, Customer Service & Efficiency
        </p>

        {/* Review badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 mb-10">
          <div className="flex items-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="font-bold text-foreground">4.9</span>
            <span className="text-sm text-muted-foreground">490+ Reviews (Facebook)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="font-bold text-foreground">4.8</span>
            <span className="text-sm text-muted-foreground">450+ Reviews (Google)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="font-bold text-foreground">5.0</span>
            <span className="text-sm text-muted-foreground">43+ Reviews (WOM)</span>
          </div>
        </div>

        {/* Testimonial cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.map((review) => (
            <div key={review.name} className="bg-muted p-6 rounded-lg text-left">
              <div className="flex mb-3">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <h3 className="font-bold text-foreground mb-2">{review.name}</h3>
              <p className="text-xs text-muted-foreground leading-relaxed">{review.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
